import { useTranslation } from "react-i18next";

const StorageProgressBar = ({ used, total }) => {
  const { t } = useTranslation();
  const percentRaw = total > 0 ? (used / total) * 100 : 0;
  let percentUsed = 0;

  if (percentRaw > 0 && percentRaw < 1) {
    percentUsed = 1;
  } else {
    percentUsed = parseFloat(Math.min(percentRaw, 100).toFixed(2));
  }

  // 根據使用百分比設定進度條顏色
  let progressColor = "progress-green";
  if (percentUsed >= 90) progressColor = "progress-red";
  else if (percentUsed >= 60) progressColor = "progress-yellow";

  return (
    <div>
      <div className="progress-container">
        <div className={`progress-bar ${progressColor}`} style={{ width: `${percentUsed}%` }}></div>
      </div>
      <div className="text-right text-gray-500" style={{ fontSize: "14px" }}>
        {t("storageUsedLabel", { used, total })}
      </div>
    </div>
  );
};

export default StorageProgressBar;
